import axios from "axios";

const quotationApi = axios.create({
  // baseURL: "http://localhost:8000/api/v1/",
  baseURL: "https://api-staging.pristinepv.co.uk/api/v1/",
  headers: {
    "Content-Type": "application/json",
  },
});

const QuotationApi = () => {
  const getPublicQuotation = async (token) => {
    try {
      const response = await quotationApi.get(`quotations/public/${token}`);

      return response.data;
    } catch (error) {
      console.error("Get public quotation API error:", error);

      throw error;
    }
  };

  const decidePublicQuotation = async (token, data) => {
    try {
      const response = await quotationApi.post(
        `quotations/public/${token}/decision`,
        data,
      );

      return response.data;
    } catch (error) {
      console.error("Decide public quotation API error:", error);

      throw error;
    }
  };

  return {
    getPublicQuotation,
    decidePublicQuotation,
  };
};

export default QuotationApi;
